import React from 'react';
import { connect } from 'react-redux';
import TabContainer from 'containers/RequestTabContainer';
import { ecoTabs } from 'helpers/WizardHelper';
import { lastWizardStep } from 'actions/wizard';

const EcoTabs = ({ wizard }) => {
  const { step } = wizard;
  if (step === lastWizardStep) return null;
  return (
    <TabContainer
      show={true}
      component={ecoTabs[step]}
      isEditable={true}
      canSubmit={true}
    />
  );
};

function mapStateToProps({ wizard }) {
  return { wizard };
}

export default connect(mapStateToProps)(EcoTabs);



// WEBPACK FOOTER //
// ./src/containers/request/ECO/EcoTabs.js